import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import Form from "../../components/common/form/Form";
import {customerSchema} from "../../schema/customerSchema";
import {getFormData} from "../../models/customerModel";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {fetchCustomerById, updateCustomer} from "../../store/customer-slice";
import {getValidatedLimit} from "../../components/Utility";

const CustomerEdit = () => {
    const params = useParams();
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.auth.selectedRole);
    const {pagination} = useSelector(state => state.customer);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items,
        updateStatus,
        fetchByIdStatus,
        error
    } = useSelector(state => state.customer);

    useEffect(() => {
        dispatch(fetchCustomerById({...userRole, id: params.customerId}));
    }, [dispatch, params.customerId, userRole]);

    const customer = items.find(item => item.id === params.customerId);

    useEffect(() => {
        if (updateStatus === "success") {
            navigator(`../../?page=${currentPage}&limit=${limit}`);
        }
    }, [updateStatus, dispatch, navigator, currentPage, limit]);

    const formSubmitHandler = (data) => {
        delete data.password;
        // Convert empty floor to undefined
        if (data.address?.floor === '') {
            data.address.floor = undefined;
        }

        dispatch(updateCustomer({
            ...userRole,
            id: params.customerId,
            data: data
        }));
    };

    const formCancelHandler = () => {
        navigator(`../../?page=${currentPage}&limit=${limit}`);
    }

    const schema = customerSchema();
    delete schema.password;
    const initialData = getFormData(customer);
    return (
        <>
            <SubHeader title="Update Customer">
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        {fetchByIdStatus === "loading" && <p>Loading...</p>}
                        {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                        {fetchByIdStatus === "success" &&
                            <Form onFormSubmit={formSubmitHandler}
                                  onFormCancel={formCancelHandler}
                                  schema={schema}
                                  inline={false}
                                  initialData={initialData}
                                  status={updateStatus}
                                  error={error}/>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default CustomerEdit;